import React, { useEffect, useState } from 'react'
import { hashHistory } from 'react-router';
import { useStyle } from "./Style";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import DialpadIcon from '@mui/icons-material/Dialpad';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import { getUserFullname, hasAuthourity } from '../../../../lib/access.es6';
import { getPartnerConfigs } from '../../../../lib/requests.es6';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import FloatingSimulator from '../../../../partner-apps/OldMutualMalawi/UssdSessions/Components/FloatingSimulator/FloatingSimulator';
import { USSDSTART_FLOW_REF } from '../../../../partner-apps/OldMutualMalawi/UssdSessions/constants';

const HomePageCta = (props) => {
  const classes = useStyle();

  const viewClaims = () => {
    hashHistory.push('admin/claims_dashboard');
  }

  const viewReports = () => {
    hashHistory.push('admin/premium_report');
  }

  const viewAnalytics = () => {
    hashHistory.push('admin/dashboards');
  }

  // Generic across any partner - mailroom resolves the org by uuid (ussd_org_uuid on this partner's
  // config) rather than a hardcoded partner map, so any partner with ussd_business_features_active set
  // gets this card automatically. Gated on SIMULATE_USSD_FLOW, not VIEW_USSD_SESSIONS - this card calls
  // mailroom's /business/simulate/start, which requires that role specifically. Lets a business user see
  // a USSD journey for a customer who isn't registered yet - the simulate endpoint builds a synthetic
  // contact from the msisdn rather than requiring an existing one.
  const [ussdBusinessFeaturesActive, setUssdBusinessFeaturesActive] = useState(false);
  useEffect(() => {
    getPartnerConfigs()
      .then(response => setUssdBusinessFeaturesActive(!!response.data.ussd_business_features_active))
      .catch(() => setUssdBusinessFeaturesActive(false));
  }, []);

  const showStartUssdSession =
    ussdBusinessFeaturesActive &&
    hasAuthourity('SIMULATE_USSD_FLOW');

  const [ussdPromptOpen, setUssdPromptOpen] = useState(false);
  const [ussdMsisdnInput, setUssdMsisdnInput] = useState('');
  const [ussdMsisdn, setUssdMsisdn] = useState('');

  const startUssdSession = () => {
    const cleaned = ussdMsisdnInput.replace(/[^0-9]/g, '');
    setUssdMsisdn(cleaned);
    setUssdPromptOpen(false);
  }

  return (
    <>
      <section className={classes.welcomewrapper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.welcomeheading}>
              <span> {props.labels.hello} {getUserFullname()} {props.labels.welcomeBack} !</span>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2} >
          <Grid item xs={12} md={3} sm={3}  style={{
          display: hasAuthourity('REGISTER_CUSTOMER') ? 'inline-block' : 'none'
        }}>
            <div className={classes.boxoptionwrapper} onClick={props.open}>
              <ul>
                <li><HowToRegOutlinedIcon /></li>
                <li>{props.labels.registerCustomer} </li>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} md={3} sm={3}  style={{
          display: hasAuthourity('VIEW_BUSINESS_REPORT') ? 'inline-block' : 'none'
        }}>
            <div className={classes.boxoptionwrapper} onClick={viewAnalytics}>
              <ul>
                <li><InsightsOutlinedIcon /></li>
                <li>{props.labels.viewAnalytics}</li>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} md={3} sm={3}  style={{
          display: hasAuthourity('VIEW_CLAIMS') ? 'inline-block' : 'none'
        }}>
            <div className={classes.boxoptionwrapper} onClick={viewClaims}>
              <ul>
                <li><InventoryOutlinedIcon /></li>
                <li>{props.labels.viewClaims}</li>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} md={3} sm={3}  style={{
          display: hasAuthourity('VIEW_BUSINESS_REPORT') ? 'inline-block' : 'none'
        }}>
            <div className={classes.boxoptionwrapper} onClick={viewReports}>
              <ul>
                <li><AssignmentIndOutlinedIcon /></li>
                <li>{props.labels.viewReports}</li>
              </ul>
            </div>
          </Grid>
          {showStartUssdSession && (
            <Grid item xs={12} md={3} sm={3}>
              <div className={classes.boxoptionwrapper} onClick={() => setUssdPromptOpen(true)}>
                <ul>
                  <li><DialpadIcon /></li>
                  <li>Start USSD Session</li>
                </ul>
              </div>
            </Grid>
          )}
        </Grid>
      </section>

      <Dialog open={ussdPromptOpen} onClose={() => setUssdPromptOpen(false)}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DialpadIcon color="primary" />
          Start USSD Session
        </DialogTitle>
        <DialogContent>
          <Alert severity="success" icon={<CelebrationOutlinedIcon />} sx={{ marginBottom: 2 }}>
            It's the real deal - experience it as your customer would. Works even if this number isn't a registered customer yet.
          </Alert>
          <TextField
            autoFocus
            label="Customer phone number"
            placeholder="233123456789"
            helperText="Include the country code, no leading + or 0"
            InputProps={{
              startAdornment: <PhoneIphoneOutlinedIcon sx={{ marginRight: 1, color: 'text.secondary' }} />
            }}
            value={ussdMsisdnInput}
            onChange={(e) => setUssdMsisdnInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && startUssdSession()}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUssdPromptOpen(false)}>Cancel</Button>
          <Button variant="contained" startIcon={<DialpadIcon />} onClick={startUssdSession}>
            Start
          </Button>
        </DialogActions>
      </Dialog>

      {ussdMsisdn && (
        <FloatingSimulator flowUuid={USSDSTART_FLOW_REF} msisdn={ussdMsisdn} autoOpen />
      )}
      <section className={classes.citybg}></section>
    </>
  )
}

export default HomePageCta